var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1DownLeftArrowB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 55H20V38l7.07 7.07L53.17 19 56 21.83l-26.1 26.1L37 55z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Down-left_arrow_B.fbae63f7.svg";
export { SvgJ1DownLeftArrowB as ReactComponent };